class PromoBanner extends HTMLElement {
    constructor() {
        super();
        this.endDate = new Date(this.getAttribute("data-end-date"));
        this.startDate = new Date(this.getAttribute("data-start-date"));
    }

    connectedCallback() {
        if (this.endDate < new Date() || this.startDate > new Date()) {
            return;
        }

        this.classList.remove("hidden");
    }

    disconnectedCallback() {
        this.classList.add("hidden");
    }
}

customElements.define("promo-banner", PromoBanner);
